import { Fab, Tooltip, Zoom } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { styled } from '@mui/material/styles';

// Botão estilizado
const WhatsAppFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  right: 24,
  backgroundColor: '#25D366',
  color: 'white',
  zIndex: 1000,
  '&:hover': {
    backgroundColor: '#128C7E',
    transform: 'scale(1.1)',
  },
  transition: 'all 0.3s ease',
  boxShadow: '0 4px 20px rgba(37, 211, 102, 0.3)',
}));

// Animação de pulsação
const PulseRing = styled('div')({
  position: 'absolute',
  top: -10,
  left: -10,
  right: -10,
  bottom: -10,
  border: '2px solid #25D366',
  borderRadius: '50%',
  animation: 'pulse 2s infinite',
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(0.9)',
      opacity: 0.8,
    },
    '70%': {
      transform: 'scale(1.2)',
      opacity: 0,
    },
    '100%': {
      transform: 'scale(0.9)',
      opacity: 0,
    },
  },
});

function WhatsAppButton() {
  // Número americano no formato E.164
  // 1 = USA country code
  // 515 = area code (Iowa)
  // 8509012 = local number
  const phoneNumber = '12179730650'; 

  const message = 'Hello! I would like more information about Brothers Fiber services.';

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const handleClick = () => {
    window.open(whatsappUrl, '_blank');
    console.log('WhatsApp button clicked');
  };

  return (
    <Tooltip 
      title="Contact us on WhatsApp"
      placement="left"
      TransitionComponent={Zoom}
      arrow
    >
      <WhatsAppFab 
        aria-label="WhatsApp"
        onClick={handleClick}
        size="large"
      >
        <WhatsAppIcon sx={{ fontSize: 28 }} />
        <PulseRing />
      </WhatsAppFab>
    </Tooltip>
  );
}

export default WhatsAppButton;
